import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dialoCodeFilter',
    pure: false
})
export class DialoCodeFilterPipe implements PipeTransform {
    transform(items: any[], filterInput: string): any {
        if (!items || !filterInput) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.name.toLowerCase().indexOf(filterInput.toLowerCase()) === 0);
    }
}

@Pipe({
    name: 'dateFormat'
  })
  export class DateFormatPipe extends DatePipe implements PipeTransform {
    transform(value: any, args?: any): any {
      return super.transform(value, 'MM/dd/yyyy');
    }
}